import React, { useEffect, useState } from "react";
import { Sparkles, Users } from "lucide-react";
import { Switch } from "./ui/kit";
import OsobaKolecko from "./OsobaKolecko";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

let tymCache = null;
/** Aktivní lidé z firmy (pro výběr, kdo odkaz uvidí) — načte se jednou. */
export function useTym() {
  const [lide, setLide] = useState(tymCache || []);
  useEffect(() => {
    if (tymCache) return;
    api.get("/api/team").then((r) => {
      tymCache = (r.data.members || []).filter((m) => m.active !== false);
      setLide(tymCache);
    }).catch(() => setLide([]));
  }, []);
  return lide;
}

const krestni = (name) => (name || "").trim().split(/\s+/)[0] || name;

/**
 * Kdo odkaz na dokument uvidí + jestli ho smí otevřít AI asistent.
 * `komu` = [] → všichni, kdo vidí klienta / případ; jinak jen vybraní
 * (majitel a autor vždy). Schovává se jen v ProfitPilotu — přístup
 * k souborům dál hlídá disk firmy.
 */
export default function KdoUvidi({ komu, onKomu, ai, onAi, testid = "kdo-uvidi" }) {
  const lide = useTym();
  const { user } = useAuth();
  const vsichni = !komu || komu.length === 0;
  const prepni = (id) => onKomu(komu.includes(id) ? komu.filter((x) => x !== id) : [...komu, id]);
  const cip = (on) => `tap md:min-h-0 pill h-10 md:h-8 border inline-flex items-center gap-1.5 t-meta font-600 transition-colors ${
    on ? "bg-ink border-ink text-white" : "bg-white border-line-strong text-sec hover:bg-inputbg"}`;
  return (
    <div className="space-y-3" data-testid={testid}>
      <div>
        <span className="label-up text-muted block mb-1.5">Kdo uvidí</span>
        <div className="flex flex-wrap gap-1.5">
          <button type="button" onClick={() => onKomu([])} aria-pressed={vsichni} data-testid={`${testid}-vsichni`}
            className={`${cip(vsichni)} px-3`}><Users size={14} /> Všichni</button>
          {lide.filter((m) => m.id !== user?.id).map((m) => {
            const on = komu.includes(m.id);
            return (
              <button key={m.id} type="button" onClick={() => prepni(m.id)} aria-pressed={on} data-testid={`${testid}-${m.id}`}
                className={`${cip(on)} pl-1 pr-3`}>
                <OsobaKolecko id={m.id} name={m.name} url={m.photo_url} size={24} />
                {krestni(m.name)}
              </button>
            );
          })}
        </div>
        <p className="t-meta text-muted mt-1.5">
          {vsichni ? "Kdo vidí zakázku, uvidí i odkaz." : "Jen vybraní — ty a majitel ho vidíte vždy."}
        </p>
      </div>
      <label className="flex items-center gap-3 rounded-[14px] bg-inputbg px-3.5 py-2.5">
        <Sparkles size={17} className="text-accent shrink-0" />
        <span className="flex-1 min-w-0">
          <span className="block t-telo md:text-[13px] font-700 text-ink">AI asistent smí otevřít</span>
          <span className="block t-meta text-muted">Claude nebo ChatGPT připojený k ProfitPilotu — soubory čte pod účtem toho, kdo se ptá.</span>
        </span>
        <Switch checked={!!ai} onChange={onAi} label="AI asistent smí otevřít" testid={`${testid}-ai`} />
      </label>
    </div>
  );
}

/** Drobný popisek do řádku: komu je odkaz vidět a jestli ho smí AI. */
export function PopisViditelnosti({ komu, ai }) {
  const lide = useTym();
  const jmena = (komu || []).map((id) => krestni(lide.find((m) => m.id === id)?.name || "")).filter(Boolean);
  return (
    <>
      {komu?.length > 0 && <span title={jmena.join(", ")}> · jen {jmena.length > 2 ? `${jmena.length} lidé` : jmena.join(", ") || "vybraní"}</span>}
      {ai && <span className="inline-flex items-center gap-0.5 text-accent" title="AI asistent smí otevřít"> · <Sparkles size={11} /> AI</span>}
    </>
  );
}
